import React, { PureComponent, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Slides from '@ifeng-fe/ui_pc_slides';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

class Slide extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };
    constructor(props) {
        super(props);

        this.state = {};

        this.config = {
            unitSize: 133,
            extension: 6,
            padding: 1,
            dots: false,
        };
    }

    render() {
        const { content } = this.props;

        return (
            <div className={styles.phoenix}>
                <div className={styles.phoenix_wrap}>
                    <div className={styles.slide_container}>
                        <div>
                            <Slides
                                config={this.config}
                                content={content.map((item, index) => {
                                    return { src: item.src, url: item.url };
                                })}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Slide);
